module.exports = __webpack_public_path__ + "public/img/icon_phone.5fd392f5.png";